import { ApiClient } from '@webapp/core/services/ApiClient'
import { VendorRepository } from './VendorRepository'

export const vendorRepository = new VendorRepository({
  httpClient: ApiClient,
})
